module.exports = __webpack_public_path__ + "img/b01.416cc48d.png";